import { Component } from '@angular/core';
import { AlertService } from './alert.service';

@Component({
    selector: 'app-alert',
    template: `
        <ngb-alert
            *ngFor="let alert of alertService.alerts$ | async"
            class="text-break"
            [type]="alert.type"
            [dismissible]="alert.dismissible"
            (close)="alertService.closeAlert(alert)">
            <div [innerHTML]="alert.message"></div>
        </ngb-alert>
    `,
    standalone: false
})

export class AlertComponent {

    constructor(public alertService: AlertService) {}

}
